import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { ScopedAssistantProgress } from '@components/ScopedAssistantChat';
import { buildStatusOf, draftWritesOf } from './buildSteps';

const IDLE: ScopedAssistantProgress = { sending: false, reconnecting: false, steps: [] };

export const useBuildProgress = () => {
  const [progress, setProgress] = useState<ScopedAssistantProgress>(IDLE);
  const onProgress = useCallback((next: ScopedAssistantProgress) => setProgress(next), []);
  const status = useMemo(() => buildStatusOf(progress), [progress]);
  return { progress, status, onProgress };
};

export const useDraftFollowsAgent = (steps: ScopedAssistantProgress['steps'], refetchDraft: () => void) => {
  const seen = useRef(new Set<string>());
  useEffect(() => {
    const fresh = draftWritesOf(steps).filter((key) => !seen.current.has(key));
    if (fresh.length === 0) return;
    fresh.forEach((key) => seen.current.add(key));
    refetchDraft();
  }, [refetchDraft, steps]);
};
